module.exports = __webpack_public_path__ + "static/media/C08.38e7a4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/decors/C08.png
// module id = 213
// module chunks = 0